/**
 * Reveals the email credentials form on Login / Register (hidden until clicked).
 */
import React from "react";
import PropTypes from "prop-types";
import { TvButton, TvDiv } from "@trustvid/design-system";
import { AUTH_GOOGLE_SSO_COPY } from "./loginPageContent";

const AuthContinueWithEmailButton = ({ onClick }) => (
  <TvDiv className="d-grid mb-3">
    <TvButton
      type="button"
      color="light"
      className="tv-login-page__google-sso tv-login-page__email-toggle"
      data-testid="auth-continue-with-email"
      onClick={onClick}
    >
      {AUTH_GOOGLE_SSO_COPY.continueWithEmail}
    </TvButton>
  </TvDiv>
);

AuthContinueWithEmailButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default AuthContinueWithEmailButton;
